import React from 'react';
import classnames from 'classnames';
import { get } from 'lodash';

class RowItemKetQuaTimKiemThanhTra extends React.Component {

  render() {
    const { nhomDoiTuongThanhTraInfo, ma, phuongXaInfo, quanHuyenInfo, diaChi } = this.props.item;
    return (
      <tr className="tr-select">
        <td className='table-checkbox'>
          <label className="pt-control pt-checkbox pt-large">
            <input
              type="checkbox"
              checked={this.props.item.selected || false}
              className="pt-large"
              onChange={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}
              name="checkboxKetQua"
            />
            <span className="pt-control-indicator"></span>
          </label>
        </td>
        <td className='txt-center' onClick={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}>{this.props.count}</td>
        <td className={classnames({ 'highlighttratrung': this.props.item.daTrung })} onClick={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}>{this.props.item.ten}</td>
        <td onClick={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}>{nhomDoiTuongThanhTraInfo && nhomDoiTuongThanhTraInfo.ten ? nhomDoiTuongThanhTraInfo.ten : ''}</td>
        <td onClick={this.props.parent.handleSelectedDoiTuong.bind(this.props.parent, this.props.item)}>{ma}</td>
        <td>{get(quanHuyenInfo, 'name')}</td>
        <td>{get(phuongXaInfo, 'name')}</td>
        <td>{diaChi}</td>
      </tr>
    );
  }
}

export default RowItemKetQuaTimKiemThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemKetQuaTimKiemThanhTra.jsx